export default "/assets/images/dusty-taupe-sm.webp?64ac897bf21b0fc8f5e30dfd912a0ca8";